<template>
  <div class="captcha-drag" ref="captchaDrag" id="CaptchaDragEle">
    <div id="captchaEle" class="captcha-ele">
      <div class="verifyTip" id="verifyTip">拖动下方滑块完成拼图</div>
      <div class="lodingBox" id="lodingBox">
        <div class="lodingDot" v-for="index of 5" :key="index"></div>
      </div>
      <div class="imgContainer" id="imgSliderContainer">
        <img src="" alt="" id="shadow_img" class="shadowImg">
        <img src="" alt="" id="block_img" class="blockImg">
      </div>
      <span class="refreshIcon" id="refreshIcon"></span>
      <span class="closeIcon" id="closeSlider"></span>
      <div class="sliderContainer" id="sliderContainer">
        <div class="sliderMask">
          <div class="slider" id="loginSlider">
            <img class="sliderIcon" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAaBAMAAAApqzNLAAAAD1BMVEUAAAD///////////////+PQt5oAAAABHRSTlMA5kpJG2qUMwAAADpJREFUKM9jMBRmAANmQQMwDRIQcYQwGV0EwDRIwMUFwmRxcQDTQIFRsSEghi0uFYUgTCZBBTANFAAAPS0mdGV7YaEAAAAASUVORK5CYII=">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/*eslint-disable*/
import CaptchaSdk from './captcha-sdk';


const Captcha = new CaptchaSdk();

export default {
  name: 'LoginCaptcha',
  data() {
    return {
      checkLoginTimer: false,
      loginTarget: ''
    }
  },
  props: {
    captchaData: {}
  },


  mounted() {
    this.$element = document.getElementById('CaptchaDragEle');
    this.captchaEle = this.$element.querySelector('#captchaEle');
    this.verifyTip = this.captchaEle.querySelector('.verifyTip');
    console.log(this.captchaData)
    Captcha.init({
      suid: this.captchaData.suId || '',
      reqId: this.captchaData.reqId || '',
      uuid: this.captchaData.uuid || '',
      did: this.captchaData.did || '',
      onSuccess: token => {
        this.changeTopText('验证通过', '#00cea0');
        setTimeout(() => {
          Captcha.close();
        }, 500);
        this.$emit('captchaSuccess', token);
      },
      onFail: msg => {
        let txt = msg || '验证失败,请重试';
        this.changeTopText(txt, '#ff6363');
      },
      onRefresh: () => {
        Captcha.refresh();
      },
      onClose: () => {
        this.$emit('closeCaptcha');
      },
      onReset: () => {
        this.changeTopText('拖动下方滑块完成拼图', 'rgb(0, 0, 0)');
      },
    });
  },

  methods: {
    // 顶部提示语操作
    changeTopText(text = '', color = 'rgb(0, 0, 0)') {
      if (text) {
        this.verifyTip.innerText = text;
      }
      if (color) {
        this.verifyTip.style.color = color;
      }
    }
  },
}
</script>

<style lang="less" scoped>
.captcha-drag {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  position: absolute;
  z-index: 10;
  top: 0;
  left: 0;
  border-radius: 24px;
}

.captcha-ele {
  position: relative;
  top: 80px;
  box-sizing: content-box;
  width: 340px;
  height: 326px;
  margin: 0 auto;
  background: #fff;
  border-radius: 15px;
}
.bind-phone-main .captcha-ele {
  top: 15px;
}
.enter-forget .captcha-ele {
  top: 5px;
}

.blockImg,
#mgtvRiskCapBlockImg_2021 {
  position: absolute;
  left: 0;
  bottom: 0;
  cursor: grab;
}

.blockImg:active {
  cursor: grabbing;
}

.imgContainer {
  position: relative;
  width: 300px;
  height: 200px;
  font-size: 0;
  margin: 0 auto;
  visibility: hidden;
  cursor: pointer;
}

.shadowImg,
#mgtvRiskCapShadowImg_2021 {
  position: relative;
  width: 100%;
  height: 200px;
  border-radius: 10px;
  cursor: grab;
}

.sliderContainer {
  box-sizing: border-box;
  position: relative;
  width: 300px;
  height: 16px;
  background: #e4e4e4;
  border-radius: 8px;
  text-align: center;
  margin: 20px auto;
}

.captcha-drag .verifyTip {
  height: 20px;
  padding: 16px 0 13px 20px;
  font-size: 14px;
  width: 251px;
  margin-bottom: 5px;
  line-height: 15px;
}

.captcha-drag .closeIcon {
  position: absolute;
  width: 16px;
  height: 16px;
  top: 15px;
  right: 20px;
  cursor: pointer;
  background: url('@/assets/images/close.png') no-repeat center;
  background-size: 16px 16px;
  display: block;
}

.captcha-drag .refreshIcon {
  position: absolute;
  width: 16px;
  height: 16px;
  top: 15px;
  right: 50px;
  cursor: pointer;
  background: url('@/assets/images/refresh.png') no-repeat center;
  background-size: 16px 16px;
  display: block;
}

.sliderContainer_active .sliderMask {
  height: 38px;
  border-width: 1px;
}

.sliderContainer_success .slider {
  background-color: #00cea0 !important;
}

.sliderContainer_fail .slider {
  border: 1px solid #ff6363;
  background-color: #ff6363 !important;
}

.sliderContainer_active .sliderText,
.sliderContainer_success .sliderText,
.sliderContainer_fail .sliderText {
  display: none;
}

.sliderMask {
  position: absolute;
  left: 0;
  top: 0;
  height: 40px;
  border-top-left-radius: 20px;
  -webkit-border-top-left-radius: 20px;
  -moz-border-radius-topleft: 20px;
  border-bottom-left-radius: 20px;
  -webkit-border-bottom-left-radius: 20px;
  -moz-border-radius-bottomleft: 20px;
  background: #d1e9fe;
}

.slider {
  position: absolute;
  top: -8px;
  left: 0;
  width: 64px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #2682ff;
  border-radius: 16px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
  transition: background 0.2s linear;
  cursor: grab;
}

.sliderIcon {
  width: 20px;
  pointer-events: none;
}

.lodingBox {
  position: absolute;
  top: 33%;
  width: 25%;
  height: 25%;
  left: 35%;
  animation: sk-chase 2.5s infinite linear both;
}
.lodingDot {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  animation: loding-dot 2s infinite ease-in-out both;
}

.lodingDot:before {
  content: '';
  display: block;
  width: 20px;
  height: 20px;
  background-color: #ddd;
  border-radius: 100%;
  animation: loding-dot-before 2s infinite ease-in-out both;
}

.lodingDot:nth-child(1) {
  animation-delay: -1.1s;
}
.lodingDot:nth-child(2) {
  animation-delay: -1s;
}
.lodingDot:nth-child(3) {
  animation-delay: -0.9s;
}
.lodingDot:nth-child(4) {
  animation-delay: -0.8s;
}
.lodingDot:nth-child(5) {
  animation-delay: -0.7s;
}
.lodingDot:nth-child(6) {
  animation-delay: -0.6s;
}
.lodingDot:nth-child(1):before {
  animation-delay: -1.1s;
}
.lodingDot:nth-child(2):before {
  animation-delay: -1s;
}
.lodingDot:nth-child(3):before {
  animation-delay: -0.9s;
}
.lodingDot:nth-child(4):before {
  animation-delay: -0.8s;
}
.lodingDot:nth-child(5):before {
  animation-delay: -0.7s;
}
.lodingDot:nth-child(6):before {
  animation-delay: -0.6s;
}

@keyframes sk-chase {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes loding-dot {
  80%,
  100% {
    transform: rotate(360deg);
  }
}

@keyframes loding-dot-before {
  50% {
    transform: scale(0.4);
  }
  100%,
  0% {
    transform: scale(1);
  }
}

</style>
